// @ts-check

class ApiEndpoints {
  /** @type {string} Base server URL (API origin) */
  static serverURL = import.meta.env.VITE_API_BASE_URL as string;
  // "https://dc40467c0ba35578.dev.server.gymstream.app"
  // "http://192.168.1.25:8000";

  /** @type {string} (Legacy/compat) */
  static baseApiURL = ApiEndpoints.serverURL;

  /** @type {string} Base asset URL */
  static assetURL = import.meta.env.VITE_APP_ASSET_URL as string;
  // "https://gymstream-dev.s3.ap-south-1.amazonaws.com";

  static originalCustomWorkoutURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/subscriber/workouts/original`;
  static originalDefaultWorkoutURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/app/workouts/original`;

  static customWorkoutThumbnailURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/subscriber/workouts/thumbnail`;
  static defaultWorkoutThumbnailURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/app/workouts/thumbnail`;

  static convertedCustomWorkoutURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/subscriber/workouts/streaming`;
  static convertedDefaultWorkoutURL =
    // process.env.REACT_APP_ASSET_URL ||
    `${this.assetURL}/files/app/workouts/streaming`;

  /** @type {string} Full  admin base path */
  static baseAdminApi = `/app-service/api/v1`;
  /** @type {string} Full  subscriber base path */
  static baseSubscriberApi = `/subscriber-service/api/v1`;

  /** @type {string} Full  file base path */
  static baseFileApi = `/file-service/api/v1`;

  // for admin
  /** @type {string} */
  static admin = `${this.baseAdminApi}/admin`;
  static adminLogin = `${this.admin}/login`;
  static adminGoogleLogin = `${this.admin}/google-login`;
  static adminProfile = `${this.admin}/profile`;
  static getAdmin = this.admin;
  static adminChangePassword = `${this.admin}/change-password`;
  static adminForgetPassword = `${this.admin}/forget-password`;
  static adminResetPassword = `${this.admin}/reset-password`;
  static adminLogout = `${this.admin}/logout`;
  static adminStatusChange = `${this.admin}/change-status`;

  // for organisation
  /** @type {string} */
  static organisation = `${this.baseAdminApi}/organisation`;
  static createOrganisation = `${this.organisation}`;
  static getAllOrganisations = `${this.organisation}`;
  static editOrganisation = `${this.organisation}`;
  static deleteOrganisation = `${this.organisation}`;
  static organisationStatusChange = `${this.organisation}/change-status`;

  // for gym
  /** @type {string} */
  static gym = `${this.baseAdminApi}/gym`;
  static createGym = `${this.gym}`;
  static getAllGyms = `${this.gym}`;
  static editGym = `${this.gym}`;
  static deleteGym = `${this.gym}`;
  static gymStatusChange = `${this.gym}/change-status`;

  // for staff
  /** @type {string} */
  static staff = `${this.baseAdminApi}/staff`;
  static createStaff = `${this.staff}`;
  static getAllStaff = `${this.staff}`;
  static getStaffById = `${this.staff}`;
  static editStaff = `${this.staff}`;
  static deleteStaff = `${this.staff}`;
  static staffStatusChange = `${this.staff}/change-status`;

  // for plans
  /** @type {string} */
  static plan = `${this.baseSubscriberApi}/plan`;
  static getPlans = `${this.plan}`;
  static createPlan = `${this.plan}`;
  static editPlan = `${this.plan}`;
  static getPlanById = `${this.plan}`;
  static deletePlan = `${this.plan}`;

  // for subscription screens
  /** @type {string} */
  static addSubscriptionScreen = `${this.baseAdminApi}/subscription`;
  static getSubscription = `${this.baseAdminApi}/subscription`;
  static subscriptionInvoice = `${this.baseAdminApi}/invoice`;

  /** @type {string} */
  static screen = `${this.baseAdminApi}/screen`;
  static getSubscriberScreens = `${this.screen}/subscriber`;
  static getOrganisationScreens = `${this.screen}/organisation`;
  static getSubscriptionScreens = `${this.screen}/subscription`;
  static upgradeSubscriberScreen = `${this.screen}/upgrade`;
  static downgradeSubscriberScreen = `${this.screen}/downgrade`;
  static cancelSubscriberScreen = `${this.screen}/cancel`;

  //for device
  static device = `${this.baseAdminApi}/device`;
  static createDevice = `${this.device}`;
  static getAllDevices = `${this.device}`;
  static getDeviceById = `${this.device}`;
  static editDevice = `${this.device}`;
  static deleteDevice = `${this.device}`;
  static deviceStatusChange = `${this.device}/change-status`;

  // for subscriber (admin app)
  /** @type {string} */
  static subscriber = `${this.baseSubscriberApi}/subscriber`;
  static createSubscriber = `${this.subscriber}`;
  static getAllSubscribers = `${this.subscriber}`;
  static getSubscriberById = `${this.subscriber}`;
  static editSubscriber = `${this.subscriber}`;
  static deleteSubscriber = `${this.subscriber}`;
  static subscriberStatusChange = `${this.subscriber}/change-status`;
  static subscriberDashboardToken = `${this.subscriber}/dashboard-token`;

  // for workout(admin app)
  /** @type {string} */
  static workout = `${this.baseSubscriberApi}/workout`;
  static createWorkout = `${this.workout}`;
  static getAllWorkouts = `${this.workout}`;
  static getWorkoutById = `${this.workout}`;
  static editWorkout = `${this.workout}`;
  static deleteWorkout = `${this.workout}`;

  // for file upload
  static file = `${this.baseFileApi}/file/workout/app`;
  static uploadFile = `${this.file}`;
  static uploadThumbnail = `${this.file}/thumbnail`;

  // for session
  /** @type {string} */
  static session = `${this.baseSubscriberApi}/session`;
  static createSession = `${this.session}`;
  static getAllSessions = `${this.session}`;
  static getSessionById = `${this.session}`;
  static editSession = `${this.session}`;
  static deleteSession = `${this.session}`;
  static changeSessionStatus = `${this.session}/change-status`;
  static duplicateSession = `${this.session}`;

  // for session
  /** @type {string} */
  static sessionFormat = `${this.baseSubscriberApi}/session-format`;
  static getSessionFormats = `${this.sessionFormat}/session`;
  static createSessionFormat = `${this.sessionFormat}/session`;
  static updateSessionFormat = `${this.sessionFormat}/session`;
  static createSessionExerciseBeginner = `${this.baseSubscriberApi}/session`;

  // for session format block
  /** @type {string} */
  static sessionFormatBlock = `${this.baseSubscriberApi}/session-format-block`;
  static getSessionFormatBlocks = `${this.sessionFormatBlock}/session`;
  static updateSessionFormatBlock = `${this.sessionFormatBlock}/session`;
  static createSessionFormatBlock = `${this.sessionFormatBlock}/session-format`;
  static getSessionFormatBlocksBySessionFormatId = `${this.sessionFormatBlock}/session-format`;
  static createSessionMatrixBlocks = `${this.sessionFormatBlock}/session-format`;
  static createFormatBlock = `${this.sessionFormatBlock}`;
  static createSessionGroup = `${this.sessionFormatBlock}/group/session-format`;
  static deleteSessionGropuBlockWorkout = `${this.sessionFormatBlock}/remove-workout`;
    static getSessionSummaryBySessionId = `${this.sessionFormatBlock}/session`;


  // for session format
  /** @type {string} */
  static category = `${this.baseSubscriberApi}/category`;
  static createCategory = `${this.category}`;
  static editCategory = `${this.category}`;
  static deleteCategory = `${this.category}`;
  static getAllCategories = `${this.category}/type`;

  static muscle = `${this.baseSubscriberApi}/muscle`;
  static getAllMuscles = `${this.muscle}`;
  static createMuscle = `${this.muscle}`;
  static editMuscle = `${this.muscle}`;
  static deleteMuscle = `${this.muscle}`;

  static equipment = `${this.baseSubscriberApi}/equipment`;
  static getAllEquipments = `${this.equipment}`;
  static createEquipment = `${this.equipment}`;
  static editEquipment = `${this.equipment}`;
  static deleteEquipment = `${this.equipment}`;

  static metric = `${this.baseSubscriberApi}/metric`;
  static getAllMetric = `${this.metric}`;
  static createMetric = `${this.metric}`;
  static editMetric = `${this.metric}`;
  static deleteMetric = `${this.metric}`;

  static format = `${this.baseSubscriberApi}/format`;
  static getAllFormats = `${this.format}/category`;
  static createFormat = `${this.format}`;
  static editFormat = `${this.format}`;
  static deleteFormat = `${this.format}`;

  static group = `${this.baseSubscriberApi}/group`;
  static getAllGroups = `${this.group}/category`;
  static createGroup = `${this.group}`;
  static editGroup = `${this.group}`;
  static deleteGroup = `${this.group}`;

  // for segment
  static segment = `${this.baseAdminApi}/segment`;
  static createSegment = `${this.segment}`;
  static editSegment = `${this.segment}`;
  static deleteSegment = `${this.segment}`;

  // for tier
  static tier = `${this.baseAdminApi}/tier`;
  static createTier = `${this.tier}`;
  static editTier = `${this.tier}`;
  static deleteTier = `${this.tier}`;

  // for session schedule
  static sessionSchedule = `${this.baseSubscriberApi}/session-schedule`;
  static assignSessionSchedule = `${this.sessionSchedule}`;
  static getAllSessionSchedules = `${this.sessionSchedule}`;
  static deleteSessionSchedule = `${this.sessionSchedule}`;
  static getSessionScheduleByGymId = `${this.sessionSchedule}/subscriber/gym`;

  // for tax
  static tax = `${this.baseSubscriberApi}/tax`;
  static createTax = `${this.tax}`;
  static getTaxById = `${this.tax}`;
  static editTax = `${this.tax}`;
  static deleteTax = `${this.tax}`;
  static getAllTaxes = `${this.tax}`;
}

export default ApiEndpoints;
